<template>
  <div class="modal">
    <div class="modal-content">
      <div class="title">Edit Epub Page</div>
      <table class="editorTable">
        <tr>
          <td class="left-col">
            Font Size
          </td>
          <td class="right-col">
            <select v-model="size" @change="setFontSize()" class="dropdownMenuNumber">
              <option value="8pt">8</option>
              <option value="9pt">9</option>
              <option value="10pt">10</option>
              <option value="11pt">11</option>
              <option value="12pt">12</option>
              <option value="14pt">14</option>
              <option value="16pt">16</option>
              <option value="18pt">18</option>
              <option value="20pt">20</option>
              <option value="22pt">22</option>
              <option value="24pt">24</option>
              <option value="26pt">26</option>
              <option value="28pt">28</option>
              <option value="36pt">36</option>
              <option value="48pt">48</option>
              <option value="72pt">72</option>
            </select>
          </td>
          <td class="emptyCol"></td>
          <td class="left-col">
            Font Style
          </td>
          <td class="right-col">
            <select v-model="style" class="dropdownMenuText" @change="setFontStyle()">
              <option value="normal">Normal</option>
              <option value="italic">Italic</option>
              <option value="bold">Bold</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="left-col">
            Background color
          </td>
          <td class="right-col">
            <ColorPicker
              class="color-picker backgroundColor"
              :color="backgroundColor"
              v-model="backgroundColor"
              :small="true"
            />
          </td>
          <td class="emptyCol"></td>
          <td class="left-col">
            Font Line Spacing
          </td>
          <td class="right-col">
            <select v-model="lineSpacing" class="dropdownMenuNumber" @change="setFontLineSpacing()">
              <option value="8pt">8</option>
              <option value="9pt">9</option>
              <option value="10pt">10</option>
              <option value="11pt">11</option>
              <option value="12pt">12</option>
              <option value="14pt">14</option>
              <option value="16pt">16</option>
              <option value="18pt">18</option>
              <option value="20pt">20</option>
              <option value="22pt">22</option>
              <option value="24pt">24</option>
              <option value="26pt">26</option>
              <option value="28pt">28</option>
              <option value="36pt">36</option>
              <option value="48pt">48</option>
              <option value="72pt">72</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="left-col">
            Font Color
          </td>
          <td class="right-col">
            <ColorPicker
              class="color-picker fontColor"
              :color="color"
              v-model="color"
              :small="true"
            />
          </td>
          <td class="emptyCol"></td>
           <td class="left-col">
            Font Letter Spacing
          </td>
          <td class="right-col">
            <select v-model="letterSpacing" class="dropdownMenuNumber" @change="setFontLetterSpacing()">
              <option value="1px">1</option>
              <option value="2px">2</option>
              <option value="3px">3</option>
              <option value="4px">4</option>
              <option value="5px">5</option>
              <option value="6px">6</option>
              <option value="7px">7</option>
              <option value="8px">8</option>
              <option value="9px">9</option>
              <option value="10px">10</option>
              <option value="11px">11</option>
              <option value="12px">12</option>
              <option value="13px">13</option>
              <option value="14px">14</option>
              <option value="15px">15</option>
              <option value="16px">16</option>
            </select>
          </td>
        </tr>
      </table>
      <br>
      <button v-on:click.stop="editorModalClosed()" class="button is-pulled-right">Close</button>
      <button v-on:click.stop="backToDefault()" class="button is-pulled-right" style="margin-right: 10px">Default</button>
    </div>
  </div>
</template>
<script>
import ColorPicker from "./ColorPicker";
export default {
  name: 'Editor',
  components: {
    ColorPicker
  }, 
  data() {
    return {
      size: "12pt",
      color: "#000",
      backgroundColor: "#FFF",
      style: "normal",
      lineSpacing: "8pt",
      letterSpacing: "8pt",
      setFontColorOpen: false,
      setBackgroundColorOpen: false,
      style: null
    }
  },
  watch: {
    backgroundColor: {
      immediate: true, 
      handler(oldVal, newVal) {
        if (newVal != undefined && oldVal != newVal)
          this.setFontBackgroundColor()
      }
    },
    color: {
      immediate: true, 
      handler(oldVal, newVal) {
        if (newVal != undefined && oldVal != newVal)
          this.setFontColor()
      }
    },
  },
  mounted() {
    var css = `
      .vc-chrome {
        background: #fff;
        border-radius: 2px;
        box-shadow: 0 0 2px rgb(0 0 0 / 30%), 0 4px 8px rgb(0 0 0 / 30%);
        box-sizing: initial;
        width: 225px;
        font-family: Menlo;
        background-color: #fff;
        position: fixed !important;
      }

      .current-color {
        width: 67px;
        height: 34px;
        margin-top: 2px;
        margin-left: 2px;
      }
      `;
      this.style = document.createElement("style");
      if (this.style.styleSheet) {
        this.style.styleSheet.cssText = css;
      } else {
        this.style.appendChild(document.createTextNode(css));
      }
      document.getElementsByTagName("body")[0].appendChild(this.style);
  },
  methods: {
    editorModalClosed() {
      this.$emit("editorModalClosed", false);
    },
    setFontSize() {
      this.$emit("setFontSize", this.size)
    },
    setFontColor() {
      this.$emit("setFontColor", this.color)
    },
    setFontBackgroundColor() {
      this.$emit("setFontBackgroundColor", this.backgroundColor)
    },
    setFontStyle() {
      this.$emit("setFontStyle", this.style)
    },
    setFontLineSpacing() {
      this.$emit("setFontLineSpacing", this.lineSpacing)
    },
    setFontLetterSpacing() {
      this.$emit("setFontLetterSpacing", this.letterSpacing)
    },
    backToDefault() {
      location.reload();
    }
  }
}
</script>
<style scoped lang="scss">
@import "src/css/vars.scss";

.title {
  font-size: 20px;
}

.modal-content {
  width: 527px !important;
  margin-top: 12%;
  padding: 20px;
}

.color-picker {
  margin-left: 10px;
  position: absolute;
}

.dropdownMenuNumber {
  height: 36px;
  width: 42px;
}

.dropdownMenuText {
  height: 36px;
  width: 75px;
}

.editorTable {
  width: 100%;
  .left-col {
    width: 140px;
    padding: 5px
  }

  .right-col {
    width: 72px;
    padding: 5px;
    text-align: right;
  }
}

.emptyCol {
  width: 10px;
}


</style>

